import './LogisticServiceHeaderInformationSection.scss';

const LogisticServiceHeaderInformationSectionSkeletonLoader = () => {
  return (
    <div className="LogisticServiceHeaderInformationSectionSkeletonLoader">
      <div className="leftContent">
        <div className="logisticServiceTitleAndId">
          <div className="logisticNumber animationLoader" />
          <div className="logisticTitle animationLoader" />
        </div>
        <div className="logisticServiceDetailsTabsSkeletonLoader">
          {[0, 1, 2, 3, 4].map(i => (
            <div key={`tabSkeleton${i}`} className="logisticServiceDetailsTab animationLoader" />
          ))}
        </div>
      </div>
      <div className="rightContent">
        <div className="logisticStatus animationLoader" />
        <div className="logisticServiceDatesSkeletonLoader animationLoader" />
      </div>
    </div>
  );
};

export default LogisticServiceHeaderInformationSectionSkeletonLoader;
